import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chipGroupDefaultVariants = {
  "size": "md"
}
const chipGroupCompoundVariants = []

const chipGroupSlotNames = [
  [
    "root",
    "ChipGroup__root"
  ]
]
const chipGroupSlotFns = /* @__PURE__ */ chipGroupSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chipGroupDefaultVariants, getSlotCompoundVariant(chipGroupCompoundVariants, slotName))])

const chipGroupFn = memo((props = {}) => {
  return Object.fromEntries(chipGroupSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chipGroupVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...chipGroupDefaultVariants, ...compact(variants) })

export const chipGroup = /* @__PURE__ */ Object.assign(chipGroupFn, {
  __recipe__: false,
  __name__: 'chipGroup',
  raw: (props) => props,
  variantKeys: chipGroupVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chipGroupVariantKeys)
  },
  getVariantProps
})